import React from "react";
import {
  FaSearch,
  FaTimes,
} from "react-icons/fa";

import KataButton from "../ui/KataButton";

export default function KataEmptyState({ onReset }) {
  return (
    <div className="rounded-[2rem] border border-dashed border-slate-300 bg-white px-5 py-16 text-center dark:border-white/15 dark:bg-slate-900">
      <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-orange-100 text-2xl text-orange-600 dark:bg-orange-500/10 dark:text-orange-300">
        <FaSearch />
      </span>

      <h3 className="mt-5 text-xl font-semibold text-slate-950 dark:text-white">
        Aucun partenaire trouvé
      </h3>

      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-500 dark:text-slate-400">
        Modifiez vos critères de recherche ou consultez
        l’ensemble des annonces actuellement disponibles.
      </p>

      <KataButton
        icon={FaTimes}
        variant="secondary"
        className="mt-6"
        onClick={onReset}
      >
        Réinitialiser les filtres
      </KataButton>
    </div>
  );
}